export default {
  fieldBorder: '1px solid #D8D8D8',
  fieldTextColor: '#434A54',
  fieldHorizontalMargin: '15px',
  fieldFontSize: '14px',
  fieldHorizontalPadding: '0px',
}
